import { get as _get } from "lodash";
import { Request as JSONRequest } from "../helpers/request";

// the API takes at most 100 pair addresses per request
const MAX_IDS = 100;

class PairController extends JSONRequest {
  constructor() {
    super({ url: import.meta.env.VITE_BACKEND_API_URL });
  }

  /**
   * Pairs by address, each with its tokens ({ id, symbol, name, decimals }); unknown addresses are left out
   */
  async getPairs(pairIds) {
    const chunks = [];
    for (let index = 0; index < pairIds.length; index += MAX_IDS) {
      chunks.push(pairIds.slice(index, index + MAX_IDS));
    }
    const responses = await Promise.all(
      chunks.map((ids) => this.getPrepared("/v2/pairs", { ids: ids.join(","), pageSize: MAX_IDS }))
    );
    return responses.flatMap((response) => _get(response, "result", []));
  }
}

export let pair = new PairController();
